import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import cx from 'classnames';
import styles from '@redturtle/qubicaamf-theme/components/Blocks/OurServices/styles.module.css';
import CtaIcon from '@redturtle/qubicaamf-theme/components/Icons/CtaIcon';

type Props = {
  items: {
    '@id': string;
    title: string;
    link: string;
    icon: string;
  }[];
  title: string;
  isEditMode?: boolean;
};

export default function Menu({ items, title, isEditMode }: Props) {
  return (
    <div className={cx('block-inner-wrapper', styles.inner)}>
      <div className={styles.titlewrapper}>
        <h2 className={cx('block-ourservices-title', styles.title)}>{title}</h2>
      </div>
      <div className={styles.services}>
        <ul className={styles.servicesList}>
          {items?.map((item) => (
            <li
              key={item['@id']}
              className={cx('block-ourservices-service', styles.service)}
            >
              <CtaIcon iconValue={item.icon} />
              <p className={styles.icontitle}> {item.title}</p>
              {/* @ts-ignore */}
              <ConditionalLink
                condition={!isEditMode}
                item={item.link}
                openLinkInNewTab={false}
              ></ConditionalLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
